import { OrderType, QContentAuditLogOrderType } from '@exam-management/graphql';
import { type dataGridSortDirection } from '@shared/components';

type DataGridSortDirection = (typeof dataGridSortDirection)[number];

export const ORDER_TYPE: Record<DataGridSortDirection, OrderType> = {
  asc: OrderType.Asc,
  desc: OrderType.Desc,
};

export const QCONTENT_ORDER_TYPE: Record<DataGridSortDirection, QContentAuditLogOrderType> = {
  asc: QContentAuditLogOrderType.Asc,
  desc: QContentAuditLogOrderType.Desc,
};
